import React from 'react';
import { Link } from "react-router-dom";

import logo from '../assets/logo2-color.svg';
import NavbarLinks from './NavbarLinks.json';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="container">
                    <div className="grid col-2">
                        <div>
                            <div className="icon-grid">
                                <img src={logo} alt="Zoty Logo"/>
                                <h3>Zoty</h3>
                            </div>
                            <div className="muted">
                                <div className="small-icon-grid">
                                    <p><i className="fa-solid fa-location-dot"></i></p>
                                    <p>Atlanta, Georgia</p>
                                </div>
                                <div className="small-icon-grid">
                                    <p><i className="fa-solid fa-envelope"></i></p>
                                    <p><Link to="mailto:nick@zoty.us">nick@zoty.us</Link></p>
                                </div>
                            </div>
                        </div>
                        <div className="muted links">
                            {NavbarLinks.map((link, key) => {
                                return <p key={key}>
                                    {link.external ? (
                                        <a href={link.location} target="_blank" rel="nooopener noreferrer">
                                                {link.name}
                                        </a>
                                    ) : (
                                        <Link to={link.location}>{link.name}</Link>
                                    )}
                                </p>
                            })}
                        </div>
                    </div>
                    <p id="v" className="hidden">v6.11.26</p>
                </div>
            </footer>
        </>
    );
};

export default Footer;